<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item"><router-link to="/accounting/accounts">{{ $t('coa')}}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('chart_of_account_import')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave">
                <i class="fa fa-floppy-o"></i> {{ $t('save') }}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <select class="form-control form-control-sm">
                                <option value="0">Quickbook</option>
                                <option value="1">System Template</option>
                            </select>
                        </div>
                        <div class="col-sm-10">
                            <input type="file" class="form-control" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ref="file" style="display: none;" @change="onUpload">
                            <button type="button" class="btn btn-success btn-sm" @click="$refs.file.click()">{{$t('choose_excel_file')}}</button>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                        <th>{{ $t('barcode')}}</th>
                                        <th>{{ $t('name')}}</th>
                                        <th>{{ $t('account_type') }}</th>
                                        <th>{{ $t('description') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in records" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td v-if="!isNull(ret.Num)">{{ret.Num}}</td>
                                        <td v-else class="bg-red">
                                            <span style="color: #fff;">Requiured</span>
                                        </td>
                                        <td>{{ret.Name}}</td>
                                        <td>{{ret.AccountTypeName}}</td>
                                        <td>{{ret.Description}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return {
            records: [],
            header: {
                'Content-Type': 'multipart/form-data'
            },
            typeId: 0
        }
    },
    methods: {
        onUpload(){
            var formData = new FormData();
            formData.append("TypeId", this.typeId);
            formData.append('File', this.$refs.file.files[0]);
            let loading = this.$loading.show();
            this.$api().post('accounting/account/import', formData, this.header).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Coas;
                }
            }).finally(() => { loading.hide(); });
        },
        onSave(){
            let loading = this.$loading.show();
            this.$api().post('accounting/account/import/save', this.records).then(res => {
                if(this.$isValid(res)){
                    this.$router.go(-1);
                }
            }).finally(() => { loading.hide(); });
        },
        isNull(value){
            if(value == undefined || value == null || value == '') return true;
            return false;
        }
    }
}
</script>